export const GIFTING_LIST_GET = 'src/components/Features/protected/Gifting/GIFTING_LIST_GET';
export const GIFTING_CHANGE_STATUS = 'src/components/Features/protected/Gifting/GIFTING_CHANGE_STATUS';
export const GIFTING_CHANGE_NAME_VISIBILITY = 'src/components/Features/protected/Gifting/GIFTING_CHANGE_NAME_VISIBILITY';
export const GET_GIFT_IMAGE = 'src/components/Features/protected/Gifting/GET_GIFT_IMAGE';
export const UPDATE_GIFT = 'src/components/Features/protected/Gifting/UPDATE_GIFT';
